import "./seconddiv.css";
// import { Link } from 'react-router-dom';
import PortfolioSlider from "../../../subComponents/portfolioSlider/PortfolioSlider";
import gifCodePc from "../../../images/homePage/code-pc.gif";
import gifArchiPc from "../../../images/homePage/archi-pc.gif";
import gifProdPc from "../../../images/homePage/prod-pc.gif";

export default function SecondDiv() {

    return (
        <div id="portfolio">
            <PortfolioSlider  
                background={gifCodePc}
                title="Software dev projects"
                number="01"
                link="webapp"
            />
            <PortfolioSlider 
                background={gifArchiPc}
                title="Architecture"
                number="02"
                link="architecture"
            />
            <PortfolioSlider 
                background={gifProdPc}
                title="Product Design"
                number="03"
                link="proddesign"
            />
        </div>
    )
}
